@let formControl = control();

@if (formControl) {
  @if (field().validation?.isRequired || formControl.invalid) {
    <div
      class="x-font-body-5 text-center font-extrabold"
      [ngClass]="{
        'x-text-wf-error': formControl.invalid,
      }"
    >
      @if (formControl.hasError('required')) {
        <span>Обязательное поле</span>
      } @else if (formControl.hasError('customError')) {
        <span>Ошибка валидации</span>
      } @else {
        <span>Обязательно к заполнению</span>
      }
    </div>
  }
  @if (!$hasDevicesInProducts()) {
    <div class="mb-6 rounded-xl border px-4 py-3 text-base x-text-yellow">
      Невозможно добавить устройство, так как в услугах отсутствует установка
      оборудования!
    </div>
  } @else if (!canExecute()) {
    <div class="mb-6 rounded-xl border px-4 py-3 text-base x-text-yellow">
      Невозможно добавить устройство. Это поле для другого исполнителя.
    </div>
  } @else {
    <x-request-form-devices />
  }
}
